import { useEffect, useState } from 'react'

const ClientOnlyLottie = ({ animationData, ...props }) => {
  const [LottieComponent, setLottieComponent] = useState(null)
  const [isClient, setIsClient] = useState(false)

  useEffect(() => {
    setIsClient(true)
    import('react-lottie-player').then((module) => {
      setLottieComponent(() => module.default)
    })
  }, [])

  if (!isClient || !LottieComponent) {
    return null
  }

  return <LottieComponent animationData={animationData} {...props} />
}

export default ClientOnlyLottie
